export default {
    goodsBrand: {
        page: {
            Status: 'Status',
            AddBrand: 'Add a brand',
            uploadedSize: 'The size of the uploaded logo image exceeds 50KB, please select again',
            uploadedTip: 'Suggested size: 800*800 pixels, only upload jpg/png/gif format files, files cannot exceed 50KB',
            PleaseBrand: 'Please enter the brand name',
            EditBrand: 'Edit brand',
            CreateBrand: 'Create new brand'
        },
        table: {
            name: 'Brand Name',
            code: 'Brand Code',
            LOGO: 'Brand LOGO',
            Manufacturer: 'Manufacturer',
            Operator: 'Operator',
        }
    }
};
